import baseFetch from '../baseFetch';

export const fetchUserDetails = () => baseFetch('/user?');

export const fetchUserEntitlements = () => baseFetch('/entitlements?');

export const fetchUserFavorites = async clientIp => {
  const options = {};
  if (clientIp) options.headers = new Headers({ 'x-client-ip': clientIp });
  return baseFetch('/kbyg/favorites?', options);
};

export const postUserFavorite = favoriteId =>
  baseFetch('/favorites/?', {
    method: 'POST',
    body: JSON.stringify({ spotIds: [favoriteId], type: 'spots' }),
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
    },
  });

export const deleteUserFavorite = favoriteId =>
  baseFetch('/favorites/?', {
    method: 'DELETE',
    body: JSON.stringify({ spotIds: [favoriteId], type: 'spots' }),
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
    },
  });

export const fetchUserSettings = async clientIp => {
  const options = {};
  if (clientIp) options.headers = new Headers({ 'x-client-ip': clientIp });
  return baseFetch('/user/Settings?', options);
};

export const setUserSettings = settings =>
  baseFetch('/user/Settings?', {
    method: 'PUT',
    body: JSON.stringify({ ...settings }),
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
    },
  });

export const postRecentlyVisited = params =>
  baseFetch('/user/settings/recentlyvisited?', {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      accept: 'application/json',
      'content-type': 'application/json',
    },
  });
